import React from "react";
import { SplitButton } from "primereact/splitbutton";
import { ExportFormat } from "@hooks";

interface ExportButtonProps {
  onExport: (format: ExportFormat) => void;
  isExporting?: boolean;
  disabled?: boolean;
}

/**
 * Reusable export button with CSV/XLSX format options.
 * Default action exports as XLSX. Dropdown offers CSV alternative.
 */
export function ExportButton({
  onExport,
  isExporting = false,
  disabled = false,
}: ExportButtonProps) {
  const items = [
    {
      label: "Export as CSV",
      icon: "pi pi-file",
      command: () => onExport("csv"),
    },
  ];

  return (
    <SplitButton
      label={isExporting ? "Exporting..." : "Export XLSX"}
      icon={isExporting ? "pi pi-spin pi-spinner" : "pi pi-download"}
      onClick={() => onExport("xlsx")}
      model={items}
      disabled={disabled || isExporting}
      className="p-button-sm p-button-outlined"
      severity="secondary"
    />
  );
}
